/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiCirclePauseIcon24Solid = forwardRef('MediaUiCirclePauseIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM8 7.6a.6.6 0 0 1 .6-.6h1.8a.6.6 0 0 1 .6.6v8.8a.6.6 0 0 1-.6.6H8.6a.6.6 0 0 1-.6-.6V7.6Zm5.6-.6a.6.6 0 0 0-.6.6v8.8a.6.6 0 0 0 .6.6h1.8a.6.6 0 0 0 .6-.6V7.6a.6.6 0 0 0-.6-.6h-1.8Z" })));
});
